import { useSession } from "@/lib/session";
import { useCalls } from "@/lib/calls";

function roleLabel(role: string) {
  return role.charAt(0).toUpperCase() + role.slice(1);
}

export default function ProfilePage() {
  const { user, org, logout } = useSession();
  const { lineStatus, freeLine } = useCalls();

  if (!user) return null;

  return (
    <>
      <div className="top">
        <div>
          <p className="muted">Account</p>
          <h1>Profile</h1>
        </div>
        <button className="btn ghost" type="button" onClick={logout}>
          Sign out
        </button>
      </div>

      <section className="panel" style={{ maxWidth: 520 }}>
        <h3>{user.name}</h3>
        <p className="muted">{org?.name || "iPBX"} · {roleLabel(user.role)}</p>
        <dl className="kv">
          <div>
            <dt>Mobile</dt>
            <dd>{user.mobile || "—"}</dd>
          </div>
          <div>
            <dt>Extension</dt>
            <dd>{user.extension || "Unmapped"}</dd>
          </div>
          <div>
            <dt>Line status</dt>
            <dd>
              <span className={`pill ${lineStatus === "idle" ? "idle" : "live"}`}>
                {lineStatus || "idle"}
              </span>{" "}
              {(lineStatus === "inuse" || lineStatus === "busy" || lineStatus === "ringing") && (
                <button className="btn ghost" type="button" onClick={() => void freeLine()}>
                  Free line
                </button>
              )}
            </dd>
          </div>
          <div>
            <dt>Phone mode</dt>
            <dd>Desk phone (Neron auto-answer)</dd>
          </div>
        </dl>
      </section>
    </>
  );
}
